<template>
  <svg width="20" height="20" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10.002 1.25a8.817 8.817 0 0 0-5.946 2.363 8.806 8.806 0 0 0 4.58 15.137v-6.154H6.412v-2.543h2.222V8.11c0-2.207 1.304-3.403 3.308-3.403.652.01 1.303.069 1.946.175v2.163h-1.09a1.275 1.275 0 0 0-1.43 1.376v1.653h2.432l-.394 2.523h-2.043v6.154a8.805 8.805 0 0 0 4.582-15.135 8.817 8.817 0 0 0-5.944-2.365Z"
      fill="currentColor"
    />
  </svg>
</template>
